import { atom } from 'recoil';

export const errorLabelNameState = atom<string | undefined>({
  key: 'errorLabelState',
  default: undefined,
});
